function redirectToSearchResults(inputId) {
  const input = document.getElementById(inputId);
  if (!input || !input.value.trim()) return;
  window.location.href = window.Shopify.routes.root + 'search?q=' + encodeURIComponent(input.value.trim()) + '&type=product';
}

function searchForQuery(selectedInputId, resultsContainer) {
  const searchInput = document.getElementById(selectedInputId);
  const predictiveSearchSection = resultsContainer || document.getElementById('predictiveSearchResults-' + selectedInputId.split('-').pop());
  var requestResponse;
  predictiveSearchSection.innerHTML = '<div class="ecom-predictive-search"><div class="ecom-predictive-search-wrapper"><div class="predictive-search-loading">Buscando...</div></div></div>';
  fetch(
    window.Shopify.routes.root +
    'search/suggest?q=' + encodeURIComponent(searchInput.value) + '&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title&section_id=header-predictive-search'
  )
    .then((response) => {
      requestResponse = response;
      return response.text();
    })
    .then((text) => {
      if (!requestResponse.ok) {
        throw new Error(`${requestResponse.status}: ${text}`);
      }

      const resultsMarkup = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('#shopify-section-header-predictive-search').innerHTML;
      predictiveSearchSection.innerHTML = resultsMarkup;
    })
    .catch((error) => {
      console.error(error);
    });
}

function initMobileSearch() {
  const wrapper = document.querySelector('.predictive-search-wrapper');
  const mobileIcon = document.querySelector('.predictive-search-icon-mobile');

  if (!wrapper || !mobileIcon) return;

  const panel = document.createElement('div');
  panel.className = 'mobile-search-panel';

  const panelInput = document.createElement('input');
  panelInput.id = 'predictive-search-mobile-input';
  panelInput.className = 'predictive-search-display-input';
  panelInput.type = 'text';
  panelInput.placeholder = document.querySelector('.predictive-search-display-input').placeholder;

  const panelResults = document.createElement('div');
  panelResults.className = 'predictive-search-results-mobile';

  const panelCloseIcon = document.getElementById('mobile-search-close-icon').cloneNode(true);

  let debounceTimer;
  panelInput.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      if (panelInput.value.trim()) {
        searchForQuery('predictive-search-mobile-input', panelResults);
      } else {
        panelResults.innerHTML = '';
      }
    }, 500);
  });

  panel.appendChild(panelInput);
  panel.appendChild(panelCloseIcon);
  panel.appendChild(panelResults);

  panelCloseIcon.addEventListener('click', closePanel);

  const overlay = document.createElement('div');
  overlay.className = 'mobile-search-overlay';

  document.body.appendChild(overlay);
  document.body.appendChild(panel);

  function getHeaderBottom() {
    const header = wrapper.closest('header') ||
      wrapper.closest('[id*="header"]') ||
      wrapper.closest('[class*="header"]') ||
      wrapper.closest('section');
    return header ? header.getBoundingClientRect().bottom : wrapper.getBoundingClientRect().bottom;
  }

  function openPanel() {
    document.body.classList.add('no-scroll');
    const top = getHeaderBottom();
    panel.style.top = top + 'px';
    overlay.style.top = top + 'px';
    panel.classList.add('active');
    overlay.classList.add('active');
    panelInput.focus();
  }

  function closePanel() {
    document.body.classList.remove('no-scroll');
    panel.classList.remove('active');
    overlay.classList.remove('active');
    panelInput.value = '';
    panelResults.innerHTML = '';
  }

  mobileIcon.addEventListener('click', openPanel);
  overlay.addEventListener('click', closePanel);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closePanel();
  });
}
function hideSearch(target) {
  const searchResults = document.querySelector('#predictiveSearchResults-' + target);
  const closeSearch = document.getElementById('closeSearch-' + target);
  if (searchResults) {
    searchResults.classList.remove('visible');
  }
  if (closeSearch) {
    closeSearch.classList.add('hidden');
  }
}
if (!window._predictiveSearchInit) {
  window._predictiveSearchInit = true;

  document.addEventListener('DOMContentLoaded', initMobileSearch);

  document.addEventListener('DOMContentLoaded', () => {
    const desktopInput = document.getElementById('predictive-search-display-input-desktop');
    const mobileInput = document.getElementById('predictive-search-display-input-mobile');
    if (!desktopInput) return;

    let debounceTimer;
    desktopInput.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (desktopInput.value.trim()) {
          searchForQuery(desktopInput.id);
        } else {
          document.querySelector('.predictive-search-results-desktop').innerHTML = '';
        }
      }, 500);
    });
    mobileInput.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (mobileInput.value.trim()) {
          searchForQuery(mobileInput.id);
          const mobileResults = document.querySelector('#predictiveSearchResults-mobile');
          const closeMobileSearch = document.getElementById('closeSearch-mobile');
          closeMobileSearch.classList.remove('hidden');
          mobileResults.classList.add('visible');
        }
      }, 500);
    });
    // desktopInput.addEventListener('keydown', (e) => {
    //   if (e.key === 'Enter') {
    //     if (desktopInput.value.trim()) {
    //       redirectToSearchResults(desktopInput.id);
    //     }
    //   }
    // });
    mobileInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        if (mobileInput.value.trim()) {
          searchForQuery(mobileInput.id);
          const mobileResults = document.querySelector('#predictiveSearchResults-mobile');
          const closeMobileSearch = document.getElementById('closeSearch-mobile');
          closeMobileSearch.classList.remove('hidden');
          mobileResults.classList.add('visible');
        }
      }
    });
  });
}